"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledHeader = exports.StyledDivider = exports.StyledRadioItem = exports.StyledItem = exports.StyledRadioGroup = exports.StyledContent = exports.StyledPortal = void 0;
const RadixDropdownMenu = __importStar(require("@radix-ui/react-dropdown-menu"));
const styled_components_1 = __importStar(require("styled-components"));
const tokens_1 = require("../../../styles/tokens");
const DropdownMenu_constants_1 = require("./DropdownMenu.constants");
const CONTENT_PADDING = "0.5rem";
exports.StyledPortal = styled_components_1.default.div `
    & > [data-radix-popper-content-wrapper] {
        /*
        This is needed for the case when dropdown is used inside the modal
        so the content is not behind the modal overlay, which has z-index: 998
         */
        z-index: 999 !important;
    }
`;
const smMedia = `@media (min-width: ${tokens_1.BREAKPOINTS.sm})`;
const getContentSize = ({ $size }) => {
    if ($size) {
        if ($size === "medium") {
            return Object.assign(Object.assign({}, DropdownMenu_constants_1.dropdownMenuSizes["small"]), { [smMedia]: Object.assign({}, DropdownMenu_constants_1.dropdownMenuSizes[$size]) });
        }
        return DropdownMenu_constants_1.dropdownMenuSizes[$size];
    }
    return {
        width: "15.5rem",
    };
};
exports.StyledContent = styled_components_1.default.div `
    display: flex;
    flex-direction: column;
    gap: 0.25rem;

    ${getContentSize};
    height: initial;
    max-height: var(--radix-popper-available-height);

    padding: ${CONTENT_PADDING};

    overflow-y: auto;

    border-radius: var(--ds-border-radius);
    background-color: var(--ds-color-white);
    box-shadow: 0 4px 16px rgb(68 72 126 / 32%);

    /* This content is rendered in the portal outside */
    font-weight: 400;
    font-family: var(--ds-font-family);
    font-style: normal;
    color: var(--ds-color-zinc);
`;
exports.StyledRadioGroup = (0, styled_components_1.default)(RadixDropdownMenu.RadioGroup) `
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
`;
const SharedItemStyle = (0, styled_components_1.css) `
    display: block;
    width: 100%;

    padding: 0.5rem;
    border-radius: var(--ds-border-radius);

    outline: none;
    cursor: pointer;

    &:not([data-disabled]):hover {
        background-color: var(--ds-color-grey-5);
    }
    &[tabindex]:not([tabindex="-1"])[data-highlighted]:focus {
        box-shadow: 0 0 0 2px var(--ds-color-white),
            0 0 0 4px var(--ds-color-blue-100);
    }
    &[tabindex]:not([tabindex="-1"])[data-highlighted]:hover {
        background-color: var(--ds-color-grey-5);
        box-shadow: none;
    }
    &[tabindex]:not([tabindex="-1"])[data-highlighted]:active {
        background-color: var(--ds-color-grey-10);
    }

    &[data-disabled] {
        color: var(--ds-color-stone);
        cursor: not-allowed;

        p {
            color: var(--ds-color-stone);
        }
        svg {
            fill: var(--ds-color-stone);
        }
    }
`;
exports.StyledItem = (0, styled_components_1.default)(RadixDropdownMenu.Item) `
    ${SharedItemStyle}
`;
exports.StyledRadioItem = (0, styled_components_1.default)(RadixDropdownMenu.RadioItem) `
    ${SharedItemStyle}

    position: relative;
    overflow: hidden;

    &[data-state="checked"] {
        background-color: var(--ds-color-blue-10);
    }
    &[data-state="checked"]::before {
        content: "";
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;

        width: 0.25rem;
        background-color: var(--ds-color-blue-100);
    }
    &[data-state="checked"][data-disabled]::before {
        background-color: var(--ds-color-stone);
    }
`;
exports.StyledDivider = (0, styled_components_1.default)(RadixDropdownMenu.Separator) `
    height: 1px;
    margin: 0.25rem -${CONTENT_PADDING};

    background-color: var(--ds-color-silver);
`;
exports.StyledHeader = styled_components_1.default.h2 `
    margin: 0.5rem;
    font-size: 1rem;
    font-weight: normal;
`;
//# sourceMappingURL=DropdownMenu.styles.js.map